import { render, staticRenderFns } from "./MyTransactions.vue?vue&type=template&id=5c5f51cc&"
import script from "./MyTransactions.vue?vue&type=script&lang=js&"
export * from "./MyTransactions.vue?vue&type=script&lang=js&"
import style0 from "./MyTransactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports